/**
 * @@deprecated Use IconButton from da-ds instead
 */
import React, { useContext } from 'react';
import classnames from 'classnames';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { OffsetModifier } from '@wix/da-ds/pkg/popper/types';

import s from './IconButton.scss';

export interface Props {
  className?: any;
  disabled?: boolean;
  noHoverEffect?: boolean;
  noActiveEffect?: boolean;
  tooltipClassName?: string;
  tooltipText?: string;
  tooltipOffset?: OffsetModifier;
  onClick?: (e) => void;
  onMouseEnter?: (e) => void;
  onMouseLeave?: (e) => void;
  biData?: BiEvent;
  innerRef?: (button: HTMLButtonElement) => void;
  tabIndex?: -1 | 0;
  // 'aria-label'?: string;
}

const IconButton: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  tooltipClassName,
  tooltipText,
  tooltipOffset,
  disabled,
  noHoverEffect,
  noActiveEffect = noHoverEffect,
  onClick,
  children,
  biData,
  ...restProps
}) => {
  const isMobile = useContext(MobileContext);

  const showHoverEffect = !(noHoverEffect ?? isMobile);
  const showActiveEffect = !(noHoverEffect ?? isMobile);

  return (
    <BiButton
      onClick={!disabled ? onClick : undefined}
      className={classnames(
        s['root'],
        disabled && s['disabled'],
        showHoverEffect && s['with-hover-effect'],
        showActiveEffect && s['with-active-effect'],
        className
      )}
      biData={biData}
      disabled={disabled}
      {...restProps}
    >
      {!isMobile && tooltipText ? (
        <SimpleTooltip
          usePortal
          listenOnClicks={false}
          portalClassName={tooltipClassName}
          text={tooltipText}
          offsetModifier={tooltipOffset}
        >
          {children}
        </SimpleTooltip>
      ) : (
        children
      )}
    </BiButton>
  );
};
IconButton.displayName = 'IconButton';

export default IconButton;
